// NATIVE

// INSTALLED
import { setAreasRedux, storeAreaRedux } from './areaSlice';
import { checkingPreload, unCheckingPreload } from '../loading';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {
  activeAreaService,
  createAreaService,
  desactiveAreaService,
  getAreaDetailService,
  getAreaEditService,
  getAreasByPaginateService,
  getAreasService,
  updateAreaDetailService,
} from '../../services/area.service';
import { ICreateArea } from '../../commons/interfaces/area.interface';
import { setSucursalesSelectRedux } from '../sucursal';

// CUSTOM

export const getAreaStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAreasService();

    if (result.ok) {
      await dispatch(setAreasRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const getAreasByPagination = (page: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAreasByPaginateService(page);

    if (result.ok) {
      await dispatch(setAreasRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeCreateArea = (area: ICreateArea, percentage: any): any => {
  return async (dispatch: any) => {
    const { sucursal, ...rest } = area;
    const dataSave = {
      ...rest,
      areaId: area.sucursal.value,
    };

    const result = await createAreaService(dataSave, percentage);

    if (result.ok) {
      await dispatch(setAreasRedux(result.data));
    }

    return result;
  };
};

export const storeDetailAreas = (areaId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAreaDetailService(areaId);

    if (result.ok) {
      await dispatch(storeAreaRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeEditarAreas = (areaId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAreaEditService(areaId);

    if (result.ok) {
      await dispatch(storeAreaRedux(result.data.area));
      await dispatch(setSucursalesSelectRedux(result.data.branchs));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeEditArea = (area: any): any => {
  return async (dispatch: any) => {
    const data_save = {
      name: area.e_name,
      description: area.e_description,
      areaId: area.areaId,
      sucursalId: area.e_sucursal.value,
    };

    const result = await updateAreaDetailService(data_save);

    if (result.ok) {
      await dispatch(setAreasRedux(result.data));
    }

    return result;
  };
};

export const storeDesactiveArea = (areaId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());
    await dispatch(hideIconRequestErrors());

    const result = await desactiveAreaService(areaId);

    if (result.ok) {
      await dispatch(setAreasRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeActiveArea = (areaId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await activeAreaService(areaId);

    if (result.ok) {
      await dispatch(setAreasRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};
